import {
    getCurrentImageRect,
    computeViewData,
    getScale,
    getProjection,
} from '../canvas/selectors'
import {
    getRotation,
} from '../appliedFilters/selectors'
import {
    Rectangle,
    Position,
    Vector,
    Boundaries,
} from '../../helpers/math'
import { computeScaleAdaptedToFrame } from '../../helpers/media'

export const INIT_IMAGE_RECT = 'INIT_IMAGE_RECT'
export const initImageRect = (width, height) => ({ type: INIT_IMAGE_RECT, imageRect : new Rectangle(width, height) })

export const INIT_PROJECTION = 'INIT_PROJECTION'
export function initProjection(viewId, frame, rotation = 0, viewScale = 1) {
    return function initProjection(dispatch, getState)
    {
        const currentImageRect = getCurrentImageRect(getState())
        const frameScale = computeScaleAdaptedToFrame(frame, currentImageRect.rotate(rotation))

        dispatch({type: INIT_PROJECTION, frameScale, viewScale, frame, viewId})
    }
}

export const initProjectionWithCurrentRotationApplied = (viewId, frame) => (dispatch, getState) => {
    dispatch(initProjection(viewId, frame, getRotation(getState())))
}

export const UPDATE_IMAGE_RECT_POSITION = 'UPDATE_IMAGE_RECT_POSITION'
export const updateImageRectPosition = (position) => ({ type: UPDATE_IMAGE_RECT_POSITION, position })

export function updateImageReferencePosition(scaleFactor, vector){
    return function updateImageReferencePosition(dispatch, getState)
    {
        const imageRect = getCurrentImageRect(getState())
        const currentPos = new Position(imageRect.position.x, imageRect.position.y)

        const newPos = currentPos.move(
            vector
                .unscale(scaleFactor)
                .rotate(0 - getRotation(getState()))
        )

        dispatch(updateImageRectPosition(newPos))
    }
}

export const keepImageInBoundaries = (viewId) => (dispatch, getState) => {
    const state = getState()
    const rotation = getRotation(state)
    const scaleFactor = getScale(state, viewId)
    const { frame } = getProjection(state, viewId)

    const { offset } = computeViewData(state, viewId, frame)
    const offsetVector = offset.convertToVector()

    const boundaries = new Boundaries(getCurrentImageRect(state).scale(scaleFactor))
    const constrainedVector = boundaries.computeConstrainedVector(offsetVector)

    let delta = new Vector(
        offsetVector.x - constrainedVector.x,
        offsetVector.y - constrainedVector.y,
    )

    delta = delta.rotate(rotation)

    if(! delta.inDeadZone())
    {
        dispatch(updateImageReferencePosition(scaleFactor, delta))
    }
}
